// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"bf731b54","296":"1a76c557","453":"931c92a2"}[chunkId] + ".chunk.js";
};